import React, { useRef, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Form, InputGroup, Button, Modal } from 'react-bootstrap';
import InputGroupText from "react-bootstrap/esm/InputGroupText";

import { Datatable } from '../../../shared/datatable/Datatable';
import { userList } from "../../../shared/settings/apiConfig";
import { SelectInput, TextInput } from "../../../shared/form/FormInput";
import { Validators } from "../../../shared/utils/Validators";

import { departmentList, locationList, roleList, userAdd, userDetail, userUpdate, importUser, userBulkActive, userBulkInactive, programmeList } from "../../../shared/settings/apiConfig";
import { getApi, postApi, putApi } from "../../../shared/services/apiHelper";

import './User.scss';

const currentYear = new Date().getFullYear();
const startYear = 2000;
const years = [];
for (let year = currentYear; year >= startYear; year--) {
    years.push({ value: year, option: year });
};

const gender = [
    {
        id: "male",
        value: "Male"
    },
    {
        id: "female",
        value: "Female"
    }
];

const User = (props) => {

    const dataTable = useRef(null);
    const loggedInUserData = useSelector((state) => { return state.user });

    const getUserForm = (roleId=5, firstName='', lastName='', email='', mobile='', departmentId='', programmeId='', clientNumber='', gender='', batch='', section='', userid='') => {
        const form = {
            roleid: { value: roleId, valid: Boolean(roleId), error: '', validators: [Validators.required()] },
            firstname: { value: firstName, valid: false, error: '', validators: [Validators.required()] },
            lastname: { value: lastName, valid: false, error: '', validators: [Validators.required()] },
            email: { value: email, valid: false, error: '', validators: [Validators.email()] },
            mobile: { value: mobile, valid: false, error: '', validators: [Validators.phoneNumberValid()] },
            departmentid: { value: departmentId, valid: false, error: '', validators: [Validators.required()] },
            programmeid: { value: programmeId, valid: false, error: '', validators: [Validators.required()] },
            clientnumber: { value: clientNumber, valid: false, error: '', validators: [Validators.required()] },
            gender: { value: gender, valid: false, error: '', validators: [Validators.required()] },
            batch: { value: batch, valid: false, error: '', validators: [Validators.required()] },
            section: { value: section, valid: false, error: '', validators: [Validators.required()] },
            userid: { value: userid, valid: true, error: '', validators: [] }
        };

        if ( roleId.toString() !== "5" ) {
            form.programmeid = {...form.programmeid, valid: true, validators: []};
            form.clientnumber = {...form.clientnumber, valid: true, validators: []};
            form.gender = {...form.gender, valid: true, validators: []};
            form.batch = {...form.batch, valid: true, validators: []};
            form.section = {...form.section, valid: true, validators: []};
        };
        return form;
    };

    const editAction = (id) => {
        getApi(`${userDetail}/${id}`).then((response) => {
            let data = response.data.data[0];
            setUserData(data);
            openUserAddModal(data);
            
        }).catch((error) => {
            console.log(error)
        });
    };

    const [userModal, setUserModal] = useState(false);
    const [userForm, setUserForm] = useState(getUserForm());
    const [formValid, setFormValid] = useState(false);
    const [userData, setUserData] = useState({});
    const [message, setMessage] = useState({type: '', message: ''});
    const [formLoading, setFormLoading] = useState(false);
    const [departmentListData, setDepartmentListData] = useState([]);
    const [locationListData, setLocationListData] = useState([]);
    const [roleListData, setRoleListData] = useState([]);
    const [programmeListData, setProgramList] = useState([]);

    useEffect(() => {
        if (props?.location?.state?.userAdd) {
            openUserAddModal();
        }

        Promise.all([getRolesList(), getLocationsList(), getDepartmentList(), programListData()]).then(responses => {
            setRoleListData(responses[0]);
            setLocationListData(responses[1].map(elem => { return { value: elem.id, option: elem.title } }));
            setDepartmentListData(responses[2].map(elem => { return { value: elem.id, option: elem.title } }));
        });

        setUserForm(getUserForm());

        return () => {}
    }, []);

    useEffect(() => {
        setFormValid(Validators.validateForm(userForm));
    }, [userForm]);

    const customName = (data) => {
        return <>{data.firstname + ' ' + data.lastname}</>
    };

    const customStatus = (isActive) => {
        return <>{isActive ? 'Active' : 'Deactive'}</>
    };

    const [jsonData, setJsonData] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [fileName, setFileName] = useState("");
    const [activeUserModel, setactiveUserModel] = useState(false);
        
    const [csvUpdateData, setcsvUpdateData] = useState('');
    const [departmentvalue, setDepartment] = useState('');
    const [search, setSearch] = useState("");
    const [selectedActiveUserId, setSelectedActiveUserIds] = useState([]);
    const [selectedInActiveUserId, setSelectedInActiveUserIds] = useState([]);
   
    const [programid, setProgramIds] = useState('');
    const [activeInactveStatus, setActiveInactveStatus] = useState('');
    const [statusError, setStatusError] = useState('');
    const [userAciveCheck, setuserAciveCheck] = useState(false)
    const [showAcitveandDeactive, setShowAcitveandDeactive] = useState(false)

    const headerCheckBox = (rows) => {
        return (
            <Form.Check 
                className="d-flex align-items-center justify-content-center"
                type="checkbox"
                value={rows.length}
                checked={rows.length > 0 && rows.filter((row) => [...selectedActiveUserId, ...selectedInActiveUserId].includes(row.id) || row.rolename == "Admin").length == rows.length}
                onChange={(event) => { selectAll(event.target.checked, rows); }}
            />
        )
    };

    const checkBox = (row) => {
        if (row?.rolename == "Admin") {
            return null;
        }
        return (
            <Form.Check 
                className="d-flex align-items-center justify-content-center"    
                type="checkbox" 
                checked={row.isactive ? selectedActiveUserId.includes(row.id) : selectedInActiveUserId.includes(row.id)} 
                onChange={(event) => {
                    if ( row.id ) {
                        if ( row.isactive ) {
                            setSelectedActiveUserIds(prevState => {
                                let index = prevState.indexOf(row.id);
                                if (index > -1) {
                                    prevState.splice(index, 1);
                                } else {
                                    prevState.push(row.id);
                                }
        
                                return [...prevState];
                            });
                        } else {
                            setSelectedInActiveUserIds(prevState => {
                                let index = prevState.indexOf(row.id);
                                if (index > -1) {
                                    prevState.splice(index, 1);
                                } else {
                                    prevState.push(row.id);
                                }
        
                                return [...prevState];
                            });
                        }
                    }
                }} 
            />
        )
    };

    const config = {
        name: 'user',
        url: userList,
        columns: [
            {
                name: '', property: '', width: '50px', columnType: 'custom', customColumn: (event) => checkBox(event), customHeader: (rows) => headerCheckBox(rows)
            },
            { name: 'Name', sort: false, width: '250px', customColumn: customName },
            { name: 'ID Number', property: 'clientnumber', sort: true, width: '200px' },
            { name: 'Department Name', property: 'departmenttitle', sort: false, width: '250px' },
            { name: 'Email', property: 'email', sort: true, width: '250px' },
            { name: 'Role Name', property: 'rolename', sort: false, width: '150px' },
            { name: 'Status', property: 'isactive', sort: false, width: '150px', customColumn: customStatus },
            {
                name: '', property: '', columnType: 'actions', width: '50px',
                actions: {
                    header: "",
                    row: [
                        {
                            type: 'edit',
                            action: editAction
                        }
                    ]
                }
            },
        ],
        // field: ["id", "locationtitle", "firstname", "lastname", "email", "mobile", "rolename", "departmenttitle", "clientnumber", "isactive", "programmeid"],
        filter: [],
        sort: [{ "field": "id", "direction": "asc" }],
        pagination: true,
    };

    const selectAll = (checked, rows) => {
        let activeIds = [...selectedActiveUserId];
        let inactiveIds = [...selectedInActiveUserId];
        rows.map((row) => {
            if (row.rolename != "Admin") {
                if (row.isactive) {
                    if ( checked ) {
                        activeIds.push(row.id);
                    } else {
                        let index = activeIds.indexOf(row.id);
                        if ( index > -1 ) {
                            activeIds.splice(index, 1);
                        }
                    }
                } else {
                    if ( checked ) {
                        inactiveIds.push(row.id);
                    } else {
                        let index = inactiveIds.indexOf(row.id);
                        if ( index > -1 ) {
                            inactiveIds.splice(index, 1);
                        }
                    }
                }
            }
        });
        setSelectedActiveUserIds(activeIds);
        setSelectedInActiveUserIds(inactiveIds);

    }

    const getRolesList = () => {
        return new Promise((resolve, reject) => {
            getApi(roleList).then(response => {
                resolve(response.data.data);
            }).catch((error) => {
                reject(error);
            });
        })
    };

    const getLocationsList = () => {
        return new Promise((resolve, reject) => {
            getApi(locationList).then(response => {
                resolve(response.data.data);
            }).catch((error) => {
                reject(error);
            });
        })
    };

    const getDepartmentList = () => {
        let data = {
            "filter": loggedInUserData.roleid == 4 ? [{ "field": "departmentid", "value": loggedInUserData.departmentid, "op": "=", "join": "AND" }] : [],
        }
        return new Promise((resolve, reject) => {
            postApi(departmentList, { data }).then(response => {
                resolve(response.data.data);
            }).catch((error) => {
                reject(error);
            });
        })
    };

    const programListData = () => {
        let payload = {
            "filter": []
        }
        postApi(programmeList, payload).then((res) => {
            let resdata = res.data.data.map((elem) => {
                return { value: elem.id, option: elem.programmename }
            })
            setProgramList(resdata)
        })
    };

    const openUserAddModal = (data) => {
        if ( data ) {
            const formData = getUserForm(data.roleid, data.firstname, data.lastname, data.email, data.mobile, data.departmentid, data.programmeid, data.clientnumber, data.gender, data.batch, data.section, data.clientuserid);
            for (let key in formData) {
                formData[key] = Validators.validateFormControl(formData[key], formData[key].value);
            }
            setUserForm(formData);
        }

        setUserModal(true);
    };

    const closeUserAddModal = () => {
        setUserModal(false);
        setUserData({});
        setUserForm(getUserForm());
    };

    const departmentSelection = (event) => {
        setDepartment(event.target.value)
    };

    const programSelection = (event) => {
        setProgramIds(event.target.value)
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        if (file) {
            handleFileChange(file);
        }
    };

    const handleFileChange = (e) => {
        const file = e.target?.files[0] ? e.target?.files[0] : e;
        processFile(file);
    };

    const processFile = (file) => {

        setFileName(file.name);
        const reader = new FileReader();
        reader.onload = (event) => {
            try {
                const data = event.target.result;
                const json = parseCSVToJson(data);
                setJsonData(json);
            } catch (error) {


            }
        };
        reader.readAsText(file);
    };

    const handleBulkUserAction = (mode, api, successMessage, data) => {
        postApi(api, data)
            .then(() => {
                setActiveInactveStatus(successMessage);
                setTimeout(() => {
                    setActiveInactveStatus('')
                    setactiveUserModel(false)
                }, 2000);
            })
            .catch(error => {
                setStatusError(error?.response?.data?.message);
                setTimeout(() => {
                    setStatusError('')
                    setactiveUserModel(false)
                }, 2000);
            })
            .finally(() => {
                if ( mode == 'activate' ) {
                    setSelectedInActiveUserIds([]);
                } else if ( mode == 'deactivate' ) {
                    setSelectedActiveUserIds([]);
                }
                dataTable.current.searchData([]);
            });
    };

    const bulkActiveUser = () => handleBulkUserAction('activate', userBulkActive, 'User Activated Successfully', { data: { 'clientids': selectedInActiveUserId, 'sendactivationlink': userAciveCheck } });
    const bulkInactiveUser = () => handleBulkUserAction('deactivate', userBulkInactive, 'User Deactivated Successfully', { data: { 'clientids': selectedActiveUserId } });

    const parseCSVToJson = (csvData) => {

        const headerMapping = {
            "id": "clientnumber",
            "first name": "firstname",
            "last name": "lastname",
            "email id": "email",
            "gender": "gender",
            "phone number": "mobile",
            "batch": "batch",
            "section": "section"
        };

        const lines = csvData.split("\n");
        const headers = lines[0].split(/\t|,/).map((header) => header.trim().toLowerCase());
        const rows = lines.slice(1).filter((line) => line.trim() !== "");

        const mappedHeaders = headers.map((header) => headerMapping[header]);

        const parsedData = rows.map((row) => {
            const values = row.split(/\t|,/).map((value) => value.trim());
            const mappedData = mappedHeaders.reduce((acc, key, index) => {
                if (key) acc[key] = values[index] || "";
                return acc;
            }, {});
            return mappedData;
        });

        return { data: parsedData };

    };

    const handleModalOpen = () => setShowModal(true);

    const handleModalClose = () => {
        setShowModal(false)
        setUserModal(false);
        setFileName('');
        setcsvUpdateData('')
        setJsonData('')
        setDepartment('')
        setUserData('')
        setactiveUserModel(false)
        setuserAciveCheck(false)
    };

    const openStatusUserModel = (value) => {
        setactiveUserModel(true)
        setShowAcitveandDeactive(value)
    };

    const inputChange = (type, event) => {

        if (type === 'mobile') {
            let value = event.target.value.replace(/\D/g, '').replace(/[^0-9]/g, '');
            if (value.length > 10) {
                value = value.slice(0, 10);
            }
            event.target.value = value;
        }

        setUserForm(prevState => {
            if (type === 'roleid') {
                if ( event.target.value.toString() === "5" ) {
                    prevState.programmeid = { ...prevState.programmeid, value: '', valid: false, error: '', validators: [Validators.required()] };
                    prevState.clientnumber = { ...prevState.clientnumber, value: '', valid: false, error: '', validators: [Validators.required()] };
                    prevState.gender = { ...prevState.gender, value: '', valid: false, error: '', validators: [Validators.required()] };
                    prevState.batch = { ...prevState.batch, value: '', valid: false, error: '', validators: [Validators.required()] };
                    prevState.section = { ...prevState.section, value: '', valid: false, error: '', validators: [Validators.required()] };
                } else {
                    prevState.programmeid = { ...prevState.programmeid, value: '', valid: true, error: '', validators: [] };
                    prevState.clientnumber = { ...prevState.clientnumber, value: '', valid: true, error: '', validators: [] };
                    prevState.gender = { ...prevState.gender, value: '', valid: true, error: '', validators: [] };
                    prevState.batch = { ...prevState.batch, value: '', valid: true, error: '', validators: [] };
                    prevState.section = { ...prevState.section, value: '', valid: true, error: '', validators: [] };
                }
            }
            return {
                ...prevState,
                [type]: Validators.validateFormControl(prevState[type], event.target.value)
            }
        })
    };

    const uploadJson = () => {
        if (departmentvalue) {
            let departmentData = { departmentid: departmentvalue };

            let updatedData = jsonData.data.map(data => {
                return { ...data, ...departmentData };
            });

            jsonData.data = updatedData;
        }
        if (programid) {
            let programdata = { programmeid: programid };

            let updatedData = jsonData.data.map(data => {
                return { ...data, ...programdata };
            });

            jsonData.data = updatedData;
        }


        postApi(importUser, jsonData).then((response) => {
            setcsvUpdateData(response.data.data)

            if (response.data.data.success !== 0) {
                dataTable.current.searchData([])
            }

        }).catch((error) => {

        });

    }

    const downlaodFailedCaseCsv = () => {

        const headerMapping = {
            clientnumber: "ID",
            firstname: "First Name",
            lastname: "Last Name",
            email: "Email ID",
            mobile: "Phone Number",
            batch: "Batch",
            section: "Section",
            reason: "Reason",
        };

        const convertToCSV = (data) => {
            if (data.length === 0) return "";

            const headers = Object.keys(headerMapping);
            const headerRow = Object.values(headerMapping).join(",");

            const rows = data.map((row) =>
                headers.map((header) => `"${row[header] || ""}"`).join(",")
            );

            return [headerRow, ...rows].join("\n");
        };

        const csvData = convertToCSV(csvUpdateData.failed);

        const downloadCSV = (csv, filename) => {
            const blob = new Blob([csv], { type: "text/csv" });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.setAttribute("href", url);
            a.setAttribute("download", filename);
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        };

        downloadCSV(csvData, "failed_User.csv");
    };

    const addOrUpdateUser = (isUpdate=false, addAnotherUser=false) => {
        setFormLoading(true)
        let data = {
            "firstname": userForm.firstname.value,
            "lastname": userForm.lastname.value,
            "email": userForm.email.value,
            "mobile": userForm.mobile.value,
            "roleid": userForm.roleid.value,
            "departmentid": userForm.departmentid.value,
        };

        if (parseInt(userForm.roleid.value) === 5) {
            data.programmeid = userForm.programmeid.value;
            data.clientnumber = userForm.clientnumber.value;
            data.gender = userForm.gender.value;
            data.batch = userForm.batch.value;
            data.section = userForm.section.value;
        }

        if (isUpdate) {
            data["id"] = userData.id
            data['locationid'] = userData.locationid;
            putApi(userUpdate, { data }).then((response) => {

                setSelectedActiveUserIds([]);
                setSelectedInActiveUserIds([]);
                setMessage({message: 'User Updated Successfully', type: 'success'});

                dataTable.current.searchData([]);

                setTimeout(() => {

                    setMessage({message: '', type: ''});
                    closeUserAddModal();
                    setFormLoading(false)
                }, 3000);

            }).catch((error) => {

                setMessage({message: error.response?.data?.message[0]?.message ? error.response?.data?.message[0]?.message : error.response?.data?.message, type: 'error'});
                setTimeout(() => {
                  setFormLoading(false)
                    setMessage({message: '', type: ''});
                }, 3000);
            });
        } else {
            postApi(userAdd, { data }).then((response) => {

                setSelectedActiveUserIds([]);
                setSelectedInActiveUserIds([]);
                setMessage({message: 'User Added Successfully', type: 'success'});
                dataTable.current.searchData([]);

                if ( addAnotherUser ) {
                    setUserForm(getUserForm());
                }

                setTimeout(() => {
                  setFormLoading(false)
                    setMessage({message: '', type: ''});
                    if ( !addAnotherUser ) {
                        closeUserAddModal();
                    }

                }, 3000);

            }).catch((error) => {
                
                setMessage({message: error.response?.data?.message[0]?.message ? error.response?.data?.message[0]?.message : error.response?.data?.message, type: 'error'});
                setTimeout(() => {
                    setFormLoading(false)
                    setMessage({message: '', type: ''});
                }, 3000);
            })
        }
    };

    const clearData = () => {
        setSearch("");
        dataTable.current?.searchData([
            { field: 'firstname', value: "", op: 'LIKE', 'join': 'OR' },
            { field: 'lastname', value: "", op: 'LIKE', 'join': 'OR' }
        ]);
    }

    return (
        <div className="user-list">
            <text className='screen-head'>Users</text>
            <div className="heading-seaction" style={{ padding: '15px' }}>
                <div className="user-input-seaction" >

                    <InputGroup className="">
                        <InputGroupText className=" search" style={{ position: 'static' }} >
                            <i class="fa fa-search ml-3" ></i>
                        </InputGroupText>

                        <span class="icon-envelope-o"></span>
                        <Form.Control className={`search `} type={'text'} style={{ borderRadius: '0px 5px 5px 0px', borderLeft: 'none' }} name={"search"} placeholder={"Search by name"}
                            onChange={(event) => { setSearch(event.target.value) }}
                            value={search}
                            onKeyPress={(event) => {
                                if (event?.key === "Enter") {
                                    dataTable.current?.searchData([
                                        { field: 'firstname', value: `*${search}*`, op: 'LIKE', 'join': 'OR' },
                                        { field: 'lastname', value: `*${search}*`, op: 'LIKE', 'join': 'OR' }
                                    ]);
                                    setSelectedActiveUserIds([]);
                                    setSelectedInActiveUserIds([]);
                                }
                            }} />
                        <div className="user-button-section">
                            <button type="button" className="btn btn-secondary user-btn" onClick={() => {clearData()}}>Clear</button>
                            <button type="button" onClick={() => { openUserAddModal(); }} className="btn btn-primary user-btn" >Add User</button>
                            <button type="button" className="btn btn-primary user-btn" onClick={handleModalOpen}>Upload User List</button>
                            <button type="button" className="btn btn-primary user-btn" disabled={selectedInActiveUserId.length === 0} onClick={() => { openStatusUserModel(true) }} >Activate  ({selectedInActiveUserId.length})</button>
                            <button type="button" className="btn btn-primary user-btn" disabled={selectedActiveUserId.length === 0} onClick={() => openStatusUserModel(false)}>Deactivate ({selectedActiveUserId.length})</button>
                        </div>
                    </InputGroup>
                </div>
            </div>

            {/* <div className="d-flex p-4">
        <div className="me-3">Active Users: 40</div>
        <div className="me-3">Inactive Users: 4</div>
        <div className="me-3">Deleted Users: 4</div>
        <div className="text-center w-100"></div>
      </div> */}

            <div style={{ padding: '15px' }}>
                <Datatable ref={dataTable} config={config} />
            </div>

            <Modal className="users" show={userModal} onHide={closeUserAddModal} size="lg" centered backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title className="text-primary" style={{ fontWeight: 'bold' }}>{userData.id ? 'Update User' : 'Add User'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="padding-resp" style={{ padding: '10px 25px' }}>
                        <div>Role <span style={{ color: 'red' }}>*</span></div>
                        <div className="d-flex flex-column flex-sm-row">
                            {
                                roleListData.length > 0 && roleListData.map((role) => 
                                <div className="w-100 my-2" key={role.id}>
                                    <Form.Check
                                        id={role.id}
                                        custom
                                        type="radio"
                                        name="roleid"
                                        value={role.id}
                                        checked={userForm.roleid.value.toString() === role.id.toString()}
                                        label={role.name}
                                        onChange={(event) => inputChange('roleid', event)}
                                    />
                                </div>)
                            }
                        </div>
                    </div>

                    <div className="d-flex flex-column w-100 gap-3 padding-resp" style={{ padding: '0px 20px' }}>

                        <div className="d-flex flex-column flex-sm-row gap-3">
                            <TextInput type={'text'} name={'firstname'} label={'First Name'} placeholder={'First Name'} isMandatory={true}
                                value={userForm.firstname.value} error={userForm.firstname.error} onChange={(event) => inputChange("firstname", event)} />

                            <TextInput type={'text'} name={'lastname'} label={'Last Name'} placeholder={'Last Name'} isMandatory={true}
                                value={userForm.lastname.value} error={userForm.lastname.error} onChange={(event) => inputChange("lastname", event)} />
                        </div>

                        <div className="d-flex flex-column flex-sm-row gap-3">
                            <TextInput type={'text'} name={'email'} label={'Email'} placeholder={'Email'} isMandatory={true}
                                value={userForm.email.value} error={userForm.email.error} onChange={(event) => inputChange("email", event)} />

                            <TextInput type={'text'} name={'mobile'} label={'Phone number'} placeholder={' Phone number'} className="" isMandatory={true}
                                value={userForm.mobile.value} error={userForm.mobile.error} onChange={(event) => inputChange("mobile", event)} />
                        </div>

                        <div className="d-flex flex-column flex-sm-row gap-3">
                            <SelectInput name={'departmentid'} label={'Department'} placeholder={'Department'} className="mb-3" isMandatory={true}
                                value={userForm.departmentid.value} options={departmentListData} error={userForm.departmentid.error} onChange={(event) => inputChange('departmentid', event)} />

                            {
                                userForm.roleid.value.toString() === '5' && 
                                <SelectInput name={'programmeid'} label={'Program'} placeholder={'Program'}
                                value={userForm.programmeid.value} options={programmeListData} error={userForm.programmeid.error} onChange={(event) => inputChange('programmeid', event)} />
                            }
                        </div>

                        {
                            userForm.roleid.value.toString() === '5' ?
                            <>
                                <div className="d-flex flex-column flex-sm-row gap-3">
                                    <TextInput type={'text'} name={'clientnumber'} label={'ID'} placeholder={'ID Number'} isMandatory={true}
                                        value={userForm.clientnumber.value} error={userForm.clientnumber.error} onChange={(event) => inputChange("clientnumber", event)} />

                                    <div className="d-flex flex-column col justify-content-center">
                                        <div style={{margin: "2px 4px"}}>Gender<span style={{ color: 'red' }}>*</span></div>
                                        <div className="d-flex justify-content-start gap-5">
                                            {   
                                                gender.map((data) =>
                                                    <div className="d-flex" style={{ width: '20%' }} key={data.id}>
                                                        <Form.Check
                                                            id={data.id}
                                                            custom
                                                            type="radio"
                                                            name="gender"
                                                            value={data.id}
                                                            checked={userForm.gender.value == data.id}
                                                            label={data.value}
                                                            onChange={(event) => inputChange('gender', event)} />
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>

                                <div className="d-flex gap-3 user-flex-resp">
                                    <SelectInput type={'text'} name={'Batch'} label={'Batch'} placeholder={'Year'} isMandatory={true} className=""
                                        value={userForm.batch.value} options={years} error={userForm.batch.error} onChange={(event) => inputChange("batch", event)} />

                                    <TextInput type={'text'} name={'Section'} label={'Section'} placeholder={'Section No'} isMandatory={true}
                                        value={userForm.section.value} error={userForm.section.error} onChange={(event) => inputChange("section", event)} />
                                </div>
                            </> : null
                        }

                        {
                            userData.id && 
                            <div className="d-flex gap-3">
                                <TextInput disabled={true} type={'text'} name={'clientuserid'} label={'User ID'} placeholder={'User ID'}
                                        value={userForm.userid.value} error={userForm.userid.error}/>
                            </div>
                        }

                    </div>

                    <div className="mt-5" style={{ textAlign: 'center', width: '100%', padding: '0px 20px 0px 20px' }}>
                        <p style={{ color: message.type === 'success' ? 'green' : '#A50050' }}>{message.message}</p>
                    </div>
                </Modal.Body>
                <Modal.Footer className="d-flex" style={{ justifyContent: 'center' }}>
                    {userData.id ?
                        <Button className="user-button" disabled={!formValid || formLoading} onClick={() => addOrUpdateUser(true)}>Update User </Button> :
                        <>
                            <Button className="user-button" disabled={!formValid || formLoading} onClick={() => addOrUpdateUser(false, true)}>Create User and Add Another</Button>
                            <Button className="user-button" disabled={!formValid || formLoading} onClick={() => addOrUpdateUser(false)}>Create User </Button>
                        </>
                    }
                </Modal.Footer>
            </Modal>

            <Modal show={activeUserModel} size="md" onHide={handleModalClose} centered backdrop="static">
                <Modal.Body>
                    <>
                        {showAcitveandDeactive ? <div className="text-center">
                            <text className="text-1l">Do you want to activate the selected user(s)?</text>
                            <div className="d-flex justify-content-center align-items-center mt-3">
                                <Form.Check
                                    type="checkbox"
                                    label="Send Activation Link"
                                    id="activeusermail"
                                    onChange={(e) => setuserAciveCheck(e.target.checked)}
                                />
                            </div>
                        </div> :
                            <div>
                                <text className="d-flex align-items-center justify-content-center text-1l">Do you want to deactivate the selected user(s)?</text>
                            </div>}
                    </>

                </Modal.Body>
                <Modal.Footer>
                    <div className="w-100 text-center">
                        <div className="text-center mb-3">
                            <div className={activeInactveStatus ? "text-success" : "text-danger"}>
                                {activeInactveStatus || statusError}
                            </div>
                        </div>
                        <Button variant="secondary" onClick={handleModalClose} className="mx-2">
                            Cancel
                        </Button>
                        {showAcitveandDeactive ?
                            <Button onClick={bulkActiveUser} className="mx-2">Save</Button> : <Button onClick={bulkInactiveUser} className="mx-2">Save</Button>}
                    </div>
                </Modal.Footer>
            </Modal>



            {/* Modal for File Upload */}
            <Modal show={showModal} size="md" onHide={handleModalClose} centered backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title className="text-primary" >Upload User List</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div
                        style={{
                            border: "2px dashed #ccc",
                            borderRadius: "5px",
                            padding: "20px",
                            textAlign: "center",
                        }}
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={(e) => handleDrop(e)} // Handle drag and drop
                    >
                        <i style={{ width: '500px' }} class="fa-thin fa-cloud-arrow-up"></i>
                        <p>Drop files here</p>
                        <p>Please use the <span><a href={`${process.env.PUBLIC_URL}/sample.csv`} download="sample.csv">sample.csv </a></span>for the file structure</p>
                        <p>Supported format: xls, csv</p>
                        <p>OR</p>
                        <button className="text-primary" style={{ borderStyle: 'none', backgroundColor: 'white', }} onClick={() => document.getElementById("fileInput").click()}>Browse files</button>
                        <input
                            id="fileInput"
                            type="file"
                            style={{ display: "none" }}
                            accept=".csv, .xlsx"
                            onChange={handleFileChange}
                        />
                        {fileName && (
                            <div style={{ marginTop: "15px", textAlign: "center", color: "#007bff" }}>
                                <strong>Uploaded File:</strong> {fileName}
                            </div>
                        )}
                        {fileName ? <div style={{ width: '50%', marginLeft: '25%', }}>

                            <SelectInput name={'departmentid'} label={'Department'} placeholder={'Department'}
                                value={departmentvalue} options={departmentListData} onChange={(event) => departmentSelection(event)} />
                        </div> : ''}
                        {departmentvalue ? <div style={{ width: '50%', marginLeft: '25%' }}>

                            <SelectInput name={'program'} label={'Program'} placeholder={'program'}
                                value={programid} options={programmeListData} onChange={(event) => programSelection(event)} />
                        </div> : ''}


                        {csvUpdateData && (
                            <>
                                <div className="d-flex" style={{ marginTop: "15px", justifyContent: 'center' }}>

                                    <div style={{ padding: '10px' }}>Reject: {csvUpdateData.reject}</div>
                                    <div style={{ padding: '10px' }}> Success: {csvUpdateData.success}</div>
                                    <div style={{ padding: '10px' }}>Total: {csvUpdateData.total}</div>

                                </div>

                                <div>
                                    {csvUpdateData.failed && csvUpdateData.failed.length > 0 ?
                                        <Button style={{ marginTop: "15px", justifyContent: 'center' }} onClick={downlaodFailedCaseCsv}>Download Failed Case CSV</Button> : ''}
                                </div>
                            </>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleModalClose}>Cancel</Button>
                    <Button disabled={departmentvalue === "" || fileName === "" || programid === ""} onClick={() => uploadJson()}>Upload</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default User;